import React from 'react';

export const StepperContext = React.createContext<{
  enableNextButton: () => void;
  disableNextButton: () => void;
  nextStep: () => void;
  prevStep: () => void;
  reset: () => void;
  nextButtonDisabled: boolean;
  currentStepIndex: number;
  steps: Step[];
}>(undefined!);

type Step = {
  title: string;
  component: React.ReactElement;
};

type Props = {
  children: React.ReactNode;
  steps: Step[];
  currentStepIndex: number;
};

const StepperState = (props: Props) => {
  const [currentStepIndex, setCurrentStepIndex] = React.useState(0);
  const [nextButtonDisabled, setNextButtonDisabled] = React.useState(false);

  const render = () => {
    return (
      <StepperContext.Provider
        value={{
          nextStep: () => setCurrentStepIndex(currentStepIndex + 1),
          prevStep: () => setCurrentStepIndex(currentStepIndex - 1),
          enableNextButton: () => setNextButtonDisabled(false),
          disableNextButton: () => setNextButtonDisabled(true),
          reset: () => setCurrentStepIndex(0),
          currentStepIndex,
          nextButtonDisabled,
          steps: props.steps,
        }}
      >
        {props.children}
      </StepperContext.Provider>
    );
  };

  return render();
};

export { StepperState };
